export default __webpack_public_path__ + "static/media/i_bus-dbl_rd_tagless.3712712f.svg";